export default __webpack_public_path__ + "static/media/ftm.6f500181.svg";